class ybInputController {
    constructor($scope) {
        "ngInject";



    }
    onChange() {
        this.change && this.change()
    }

}

export default ybInputController;



// WEBPACK FOOTER //
// ./src/app/common/yb-input/yb-input.controller.js